<template>
  <div class="card-body p-0">
    <ul>
      <li :class="isCurrentPage('accounts') || isCurrentPage('accounts-passwd') || isCurrentPage('orderhistory')"> 
        <a href="#">My Account</a>
        <ul class="sub-nav">
          <li :class="isCurrentPage('accounts')"> <router-link to="/accounts" v-if="$store.state.auth"><span class="li-hyphen">-</span> Edit Your Details</router-link> </li>
          <li :class="isCurrentPage('accounts-passwd')"> <router-link to="/accounts-passwd" v-if="$store.state.auth"><span class="li-hyphen">-</span> Change Your Password</router-link> </li>
          <li :class="isCurrentPage('orderhistory')"> <router-link to="/orderhistory" v-if="$store.state.auth"><span class="li-hyphen">-</span> Order History</router-link> </li>
          <li :class="isCurrentPage('downloads')"> <router-link to="/downloads" v-if="$store.state.auth && your_downloads"  ><span class="li-hyphen">-</span> Download</router-link> </li>
        </ul>
      </li>
      <!-- <li :class="isCurrentPage('accounts')"> <router-link to="/accounts" v-if="$store.state.auth">Edit Your Details</router-link> </li>
      <li :class="isCurrentPage('accounts-passwd')"> <router-link to="/accounts-passwd" v-if="$store.state.auth">Change Your Password</router-link> </li>
      <li :class="isCurrentPage('orderhistory')"> <router-link to="/orderhistory" v-if="$store.state.auth">Order History</router-link> </li> -->
      <li :class="isCurrentPage('accounts-delegate')" v-if="hasCustomerId()"> <router-link to="/accounts-delegate" v-if="$store.state.auth">Book Elearning Courses</router-link> </li>
      <li :class="isCurrentPage('mydelegate')" v-if="hasCustomerId()"> <router-link to="/mydelegate" v-if="$store.state.auth">My Delegates</router-link> </li>
      <li :class="isCurrentPage('mycourse')"> <router-link to="/mycourse" v-if="$store.state.auth">My Courses</router-link> </li>
      <li> <router-link to="/logout" v-if="$store.state.auth">Logout</router-link> </li>
    </ul>
  </div>
</template>

<script>
import Users from "@/services/Users";
export default {
  name: "sidebar-nav",
  components: {},
  data(){
    return {
      activeClass: 'active',
      your_downloads: [],
    };
  },
  methods: {
    isCurrentPage(strMatch){
      strMatch = '/'+strMatch;
      return (this.$route.path.indexOf(strMatch) >= 0 && this.$route.path.length === strMatch.length) ? 'active' : '';
    },
    hasCustomerId(){
      return JSON.parse(this.$store.state.auth).customer_id ? true : false;
    }
  },
 mounted() {
    var auth = JSON.parse(this.$store.state.auth).customer_id;
    Users.downloadManualPDF(auth)
      .then(request => {
        this.isLoading = false;
        if (request.data.data.your_downloads) {
          this.your_downloads = request.data.data.your_downloads;
        } else {
          this.your_downloads = null;
        }
      })
    .catch(error => {});
  }
};
</script>
